function applyILRSpecificRouteMetadata(route) {
  if (!route.meta) return

  if (route.meta.title) {
    route.meta.title = route.meta.title.replace('Retailer', 'Customer')
  }

  if (route.meta.breadcrumbs) {
    route.meta.breadcrumbs = route.meta.breadcrumbs.map((breadcrumb) => ({
      ...breadcrumb,
      text: breadcrumb.text.replace('Retailer', 'Customer')
    }))
  }
}

function updateDocumentTitle(to) {
  document.title = `${to.meta.title || 'FLEWiD Tech'} - Supplier Portal`
}

function trackPageView(to) {
  if (to.matched.length <= 0 || !window.gtag) return

  const route = to.matched.map((record) => record.name).join('/')
  window.gtag('config', {
    page_title: document.title,
    page_path: route
  })
}

export function createScrollBehavior({ rootElementId = 'content' } = {}) {
  return function scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (to.hash) {
          return resolve({ selector: to.hash })
        }

        if (savedPosition) {
          return resolve(savedPosition)
        }

        if (document.getElementById(rootElementId)) {
          return resolve({ selector: `#${rootElementId}` })
        }

        return resolve({ x: 0, y: 0 })
      }, 50)
    })
  }
}

export function createBeforeEachGuard(appStore) {
  return async function beforeEach(to, from) {
    await appStore.dispatch('instructions/hideInstructions')

    const authRequired = !to.meta?.noauth
    if (authRequired || !from.name) {
      await appStore.dispatch('auth/checkSession')
    }

    const isAuthenticated = !!appStore.getters['auth/isAuthenticated']
    const featureSubscriptionEnabled =
      appStore.getters['tenant/featureSubscriptionEnabled']
    const featureCouponsEnabled =
      appStore.getters['tenant/featureCouponsEnabled']
    const orderChatEnabled = appStore.getters['tenant/orderChatEnabled']

    if (appStore.getters['tenant/isILR']) {
      applyILRSpecificRouteMetadata(to)
    }

    updateDocumentTitle(to)
    trackPageView(to)

    if (!isAuthenticated) {
      const query = !from.name ? to.query : undefined
      return authRequired ? { name: 'login', query } : true
    }

    if (to.name === 'pick-supplier') {
      return true
    }

    if (to.name === 'subscription') {
      return featureSubscriptionEnabled ? true : { name: 'dashboard' }
    }

    if (to.name === 'coupons' && !featureCouponsEnabled) {
      return { name: 'dashboard' }
    }

    if (to.name === 'order-chat-history' && orderChatEnabled === false) {
      return { name: 'dashboard' }
    }

    if (
      ['login', 'register', 'password-reset', 'invitation'].includes(to.name) ||
      !appStore.getters['preferences/supplierSelected']
    ) {
      return { name: 'pick-supplier' }
    }

    return true
  }
}

export { applyILRSpecificRouteMetadata, trackPageView, updateDocumentTitle }
